import { useRecoilState } from "recoil";
import { NoticeData } from "../../../system/types/Notice";
import { RoleCheckAtom } from "../../../system/atoms";
import { Fragment } from "react";
import {
  Grid,
  Pagination,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { CustomButtonGreen } from "../../../styles/button";
import { ModalState, ModalStateType } from "../../../system/Constants";
import {
  AppliedItem,
  MainTitle,
  RaffleContent,
  StyledEmptyBody,
} from "../../../styles/theme";
import { VehiclePc } from "../../../pages/Layout/ResponsiveScreen";
import uuid from "react-uuid";
import {
  AccommodationMainStyledTableRow,
  AccommodationNoticeIcon,
  AccommodationStyledBody,
  AccommodationStyledHead1,
  AccommodationStyledHead2,
  AccommodationStyledHead3,
  AccommodationStyledTableRow,
} from "../../../styles/accommodationStyle";
import { InitNoticeDetailData } from "../../../system/types/initObject";
import { X } from "@phosphor-icons/react";

interface AccommodationNoticeTableProps {
  setNoticeState: React.Dispatch<React.SetStateAction<ModalStateType>>;
  setSelectedNotice: React.Dispatch<React.SetStateAction<NoticeData>>;
  handleClose: () => void;
  pageNumber: number;
  setPageNumber: React.Dispatch<React.SetStateAction<number>>;
  noticeData: NoticeData[];
  totalPage: number;
}

function AccommodationNoticeTable({
  setNoticeState,
  setSelectedNotice,
  handleClose,
  pageNumber,
  setPageNumber,
  noticeData,
  totalPage,
}: AccommodationNoticeTableProps) {
  const RoleCheck = useRecoilState(RoleCheckAtom);

  const todayDate = new Date();

  const onChangeSelectedData = (state: string, noticeData: NoticeData) => {
    setNoticeState(state);
    setSelectedNotice(noticeData);
  };

  const onChangePaging = (event: React.ChangeEvent<unknown>, value: number) => {
    setPageNumber(value - 1);
  };

  return (
    <Grid container item xs={12}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RaffleContent>
            <MainTitle>휴양소 공지사항</MainTitle>
            <AppliedItem onClick={handleClose}>
              <X size={32} />
            </AppliedItem>
          </RaffleContent>
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent="right"
        mt="10px"
        style={{ minHeight: "30px" }}
      >
        {RoleCheck && (
          <CustomButtonGreen
            onClick={() => {
              onChangeSelectedData(ModalState.edit, InitNoticeDetailData);
            }}
          >
            공지사항 작성
          </CustomButtonGreen>
        )}
      </Grid>
      <TableContainer style={{ height: "520px" }}>
        <Table>
          <TableHead>
            <TableRow>
              <AccommodationStyledHead3 align="center">
                제목
              </AccommodationStyledHead3>
              <VehiclePc>
                <AccommodationStyledHead1 align="center">
                  작성자
                </AccommodationStyledHead1>
                <AccommodationStyledHead1 align="center">
                  작성일
                </AccommodationStyledHead1>
              </VehiclePc>
            </TableRow>
          </TableHead>
          <TableBody>
            {noticeData.map((item: NoticeData, idx) => {
              return (
                <Fragment key={uuid()}>
                  {item.mainStartDate &&
                  new Date(item.mainStartDate) < todayDate &&
                  (item.mainEndDate === null ||
                    new Date(item.mainEndDate) > todayDate) ? (
                    <AccommodationMainStyledTableRow
                      key={idx}
                      onClick={() =>
                        onChangeSelectedData(ModalState.detail, item)
                      }
                    >
                      <AccommodationStyledBody>
                        <AccommodationNoticeIcon
                          src="/images/VEHICLE/mainSpeaker.png"
                          alt="주요 공지사항"
                          style={{ marginRight: "12px" }}
                        />
                        {item.title}
                      </AccommodationStyledBody>
                      <VehiclePc>
                        <AccommodationStyledBody align="center">
                          {item.createBy}
                        </AccommodationStyledBody>
                        <AccommodationStyledBody align="center">
                          {item.createdAt && item.createdAt?.substring(0, 10)}
                        </AccommodationStyledBody>
                      </VehiclePc>
                    </AccommodationMainStyledTableRow>
                  ) : (
                    <AccommodationStyledTableRow
                      key={idx}
                      onClick={() =>
                        onChangeSelectedData(ModalState.detail, item)
                      }
                    >
                      <AccommodationStyledBody>
                        {item.title}
                      </AccommodationStyledBody>
                      <VehiclePc>
                        <AccommodationStyledBody align="center">
                          {item.createBy}
                        </AccommodationStyledBody>
                        <AccommodationStyledBody align="center">
                          {item.createdAt && item.createdAt?.substring(0, 10)}
                        </AccommodationStyledBody>
                      </VehiclePc>
                    </AccommodationStyledTableRow>
                  )}
                </Fragment>
              );
            })}
          </TableBody>
        </Table>
        {noticeData.length === 0 && (
          <Grid container>
            <StyledEmptyBody>현재 등록된 공지가 없습니다.</StyledEmptyBody>
          </Grid>
        )}
      </TableContainer>

      <Grid container justifyContent="center" mt="10px">
        <Pagination
          count={totalPage}
          variant="outlined"
          page={pageNumber + 1}
          showFirstButton
          showLastButton
          onChange={onChangePaging}
          style={{ textAlign: "center" }}
        />
      </Grid>
    </Grid>
  );
}

export default AccommodationNoticeTable;
